define([
	"dojo/_base/declare",
	"csi/xml",
	"csi/xml/Query"
], function(declare,xml,Query) {

	return declare(null, {
		productPath: "Child:Product",
		groupFilter: "__Parent__",
		
		_getStoreOptions: function(/*String*/url, /*csi.def.Relationship?*/r) {
			// summary: apply filter to view and remove any actions to add or remove items
			var	view = this.actionToolbar.view;
			var	relView = view.relRoot;
			relView.addQuery(new Query().RefAttr(this.groupFilter, xml.OP_EQUALS, view.getViewURL(), this.productPath));
			relView.resetActions();
			return this.inherited(arguments);
		}
	});
});